import templateUrl from "./rogers-recruiting-bonus-report-container.component.html";
import moment from 'moment'

export const RogersRecruitingBonusReportContainerComponent = {
    templateUrl,
    bindings: {
    },
    controller: class {
        constructor(apexApiUrl, rogersDashboardService, utilityService) {
            'ngInject'
            this.loaded = false;
            this.apexApiUrl = apexApiUrl;
            this.rogersDashboardService = rogersDashboardService;
            this.utilityService = utilityService;
            this.showFilters = true;
            this.filters = {
                OnboardingApprovalStartDate: moment().startOf("week").toDate(),
                OnboardingApprovalEndDate: moment().endOf("week").toDate(),
                SellingStartDate: moment().startOf("week").toDate(),
                SellingEndDate: moment().endOf("week").toDate(),
                Type: 'Summary'
            };
        }

        $onInit() {
        }

        retrieveRogersRecruitingBonusReport(params) {
            return this.rogersDashboardService.retrieveRogersRecruitingBonusReport(params)
                .then(recruitingBonusReport => {
                    this.showSummaryReport = true;
                    this.recruitingBonusReport = recruitingBonusReport;
                    return this.recruitingBonusReport;
                });
        }

        retrieveRogersRecruitingBonusBreakdownReport(params) {
            return this.rogersDashboardService.retrieveRogersRecruitingBonusBreakdownReport(params)
                .then(recruitingBonusBreakdownReport => {
                    this.showBreakdownReport = true;
                    this.recruitingBonusBreakdownReport = recruitingBonusBreakdownReport;
                    return this.recruitingBonusBreakdownReport;
                });
        }

        onRefreshData() {
            this.clearReportData();
            const params = this.generateQueryParameter();
            let loaded;
            if (this.filters.Type === 'Summary') {
                loaded = this.retrieveRogersRecruitingBonusReport(params);
            } else {
                loaded = this.retrieveRogersRecruitingBonusBreakdownReport(params);
            }
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(loaded, "Initial load failed"));
        }

        onExport() {
            const params = this.generateQueryParameter();
            const queryString = this.utilityService.queryStringify(params);
            let api;
            if (this.filters.Type === 'Summary') {
                api = "dashboards/rogers/rogers-recruiting-bonus-report.xlsx";
            } else {
                api = "dashboards/rogers/rogers-recruiting-bonus-breakdown-report.xlsx";
            }
            window.location = this.apexApiUrl + api + queryString;
        }

        clearReportData() {
            this.showBreakdownReport = false;
            this.showSummaryReport = false;
            this.recruitingBonusBreakdownReport = null;
            this.recruitingBonusReport = null;
        }

        generateQueryParameter() {
            const params = {
                BookedDaysDeadline: 45,
                InstalledDaysDeadline: 60,
                OnboardingApprovalStartDate: moment(this.filters.OnboardingApprovalStartDate).format("YYYY-MM-DD"),
                OnboardingApprovalEndtDate: moment(this.filters.OnboardingApprovalEndDate).format("YYYY-MM-DD"),
                SalesStartDate: moment(this.filters.SellingStartDate).format("YYYY-MM-DD"),
                SalesEndtDate: moment(this.filters.SellingEndDate).format("YYYY-MM-DD"),
            }
            return params;
        }
    }
}

